import SlpStreamParser from 'slippi/SlpStreamParser';
import BrepStreamParser from 'slippi/BrepStreamParser';

// The replay folders a friendlies board can follow. Each format names its
// replay files, reads them, and keeps its own remembered folder, so a Melee
// and a Project+ board don't offer each other's folder. pickerId is the
// folder picker's id, which makes the browser open it where it was last used.

export const SLIPPI_REPLAYS = {
	replayFile: /\.slp$/i,
	createParser: () => new SlpStreamParser(),
	pickerId: 'slippi-replays',
	rememberedFolderKey: 'replays',
};

export const BRAWL_ONLINE_REPLAYS = {
	replayFile: /\.brep$/i,
	createParser: () => new BrepStreamParser(),
	pickerId: 'brawl-online-replays',
	rememberedFolderKey: 'brawl-online-replays',
};
